import {createApp, ref} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2';
import helper from "@/utils/helper";
import fcmToken from "@/utils/fcm";
import i18n from '/src/locale/i18n'

import './registerServiceWorker'

// CSS
import './assets/index.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import 'bottom-sheet-vue3/css/style.css'

let app = createApp(App)
// Global Var for CartBottomSheet
app.config.globalProperties.$cart = ref(false)
// Global Var for Network Loading
app.config.globalProperties.$loading = ref(true)
// Global Var for Page Title
app.config.globalProperties.$pageTitle = ref('هتل تبرک')
app.config.globalProperties.$infoModal = ref(false)

fcmToken().then(token => console.log(token))

app
    .use(store)
    .use(router)
    .use(VueSweetalert2)
    .use(helper)
    .use(i18n)
    .mount('#app')

export default app